import { Menu } from './Menu';

declare global {
    interface Window {
        menu9Instances?: Menu[];
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const roots = document.querySelectorAll<HTMLElement>('[data-menu9]');

    window.menu9Instances = Array.from(roots).map((root) => {
        const breakpoint = Number(root.dataset.menu9Breakpoint ?? 900);

        return new Menu({
            root,
            breakpoint,
            openDelay: Number(root.dataset.menu9OpenDelay ?? 0),
            closeDelay: Number(root.dataset.menu9CloseDelay ?? 0),
            resizeDebounce: Number(root.dataset.menu9ResizeDebounce ?? 150),
        });
    });
});
